import Gradient from "react-native-linear-gradient"

export default Gradient
